import cx from 'classnames';
import { Typography } from 'antd';
import React, { ReactNode } from 'react';
import { TextProps } from 'antd/lib/typography/Text';

import { THEME } from '../../../config/commons';

import styles from './LrvText.module.scss';

const { Text } = Typography;

export interface LrvTextProps extends TextProps {
  children?: ReactNode;
  theme?: THEME;
}
export const LrvText = (props: LrvTextProps) => {
  const { className, theme = 'dark', children, ...rest } = props;
  const isDarkTheme = theme === THEME.DARK;
  const lrvProps = {
    ...rest,
    className: cx(isDarkTheme ? styles.darkText : styles.lightText, className),
  };
  return (
    <Text {...lrvProps}>
      {children}
    </Text>
  );
};